import type { DeviceModel } from '../../types/deviceModel';
import { powerPort, simpleLayout } from './layoutHelpers';

export const solar460Model: DeviceModel = {
  equipmentId: 'solar-460w',
  selfDrawWatts: 0,
  isSolar: true,
  pvStcWatts: 460,
  pvVmp: 35.4,
  pvVoc: 43,
  pvImp: 13.0,
  pvIsc: 13.7,
  powerInputs: [],
  layout: {
    simple: simpleLayout(
      [
        powerPort({ number: 1, kind: 'pvPlus', label: 'PV+', x: 18, y: 22 }),
        powerPort({ number: 2, kind: 'pvMinus', label: 'PV−', x: 54, y: 22 }),
      ],
      160,
      70
    ),
  },
};

export const battery48v100ahModel: DeviceModel = {
  equipmentId: 'battery-48v-100ah',
  selfDrawWatts: 0,
  isBattery: true,
  nominalVoltage: 51.2,
  capacityAh: 100,
  usableFraction: 0.8,
  powerInputs: [
    {
      id: 'bat',
      kind: 'battery',
      voltageMin: 40,
      voltageMax: 58,
      maxAmps: 100,
      capacityLimit: 'amps',
      plusPortNumber: 1,
      minusPortNumber: 2,
    },
  ],
  powerOutputs: [{ id: 'dc-out', kind: 'dc', voltageMin: 40, voltageMax: 58, maxWatts: 5120, portNumber: 1 }],
  layout: {
    simple: simpleLayout(
      [
        powerPort({ number: 1, kind: 'batPlus', label: 'BAT+', x: 18, y: 22 }),
        powerPort({ number: 2, kind: 'batMinus', label: 'BAT−', x: 54, y: 22 }),
      ],
      160,
      70
    ),
  },
};

export const inverter5k48vModel: DeviceModel = {
  equipmentId: 'inverter-5k-48v',
  selfDrawWatts: 20,
  isInverter: true,
  requiresBatteryToStart: true,
  inverterEfficiency: 0.97,
  maxDischargeAmps: 120,
  powerInputs: [
    {
      id: 'pv1',
      kind: 'pv',
      mpptId: 'mppt-1',
      plusPortNumber: 1,
      minusPortNumber: 2,
      voltageMax: 500,
      mpptVoltageMin: 150,
      mpptVoltageMax: 425,
      maxWatts: 3250,
      maxAmps: 13,
      maxIsc: 16.5,
      startupVoltage: 125,
    },
    {
      id: 'pv2',
      kind: 'pv',
      mpptId: 'mppt-2',
      plusPortNumber: 3,
      minusPortNumber: 4,
      voltageMax: 500,
      mpptVoltageMin: 150,
      mpptVoltageMax: 425,
      maxWatts: 3250,
      maxAmps: 13,
      maxIsc: 16.5,
      startupVoltage: 125,
    },
    {
      id: 'bat',
      kind: 'battery',
      plusPortNumber: 5,
      minusPortNumber: 6,
      voltageMin: 40,
      voltageMax: 60,
      maxAmps: 120,
      capacityLimit: 'amps',
    },
    { id: 'ac-in', kind: 'ac', portNumber: 8, maxWatts: 5000 },
  ],
  powerOutputs: [
    { id: 'ac-out', kind: 'ac', portNumber: 7, voltageMin: 220, voltageMax: 240, maxWatts: 5000 },
  ],
  layout: {
    simple: simpleLayout(
      [
        powerPort({ number: 1, kind: 'pvPlus', label: 'PV1+', x: 12, y: 18 }),
        powerPort({ number: 2, kind: 'pvMinus', label: 'PV1−', x: 42, y: 18 }),
        powerPort({ number: 3, kind: 'pvPlus', label: 'PV2+', x: 72, y: 18 }),
        powerPort({ number: 4, kind: 'pvMinus', label: 'PV2−', x: 102, y: 18 }),
        powerPort({ number: 5, kind: 'batPlus', label: 'BAT+', x: 12, y: 44 }),
        powerPort({ number: 6, kind: 'batMinus', label: 'BAT−', x: 42, y: 44 }),
        powerPort({ number: 7, kind: 'ac', label: 'AC out', x: 72, y: 44 }),
        powerPort({ number: 8, kind: 'ac', label: 'AC in', x: 102, y: 44 }),
      ],
      220,
      90
    ),
  },
};

/** Always-on AC source for Logic (grid / wall receptacle). */
export const wallOutletAcModel: DeviceModel = {
  equipmentId: 'wall-outlet-ac',
  selfDrawWatts: 0,
  isMainsOutlet: true,
  powerInputs: [],
  powerOutputs: [
    { id: 'ac-out', kind: 'ac', portNumber: 1, voltageMin: 220, voltageMax: 240, maxWatts: 3600 },
  ],
  layout: {
    simple: simpleLayout(
      [powerPort({ number: 1, kind: 'ac', label: 'AC out', x: 36, y: 22 })],
      120,
      70
    ),
  },
};
